











import '@/assets/scss/pages/page-auth.scss';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';

import { PermissionMixin } from '@/mixins/PermissionMixin';
import FlixcheckIntegrationSettings from './integrations/flixcheck/FlixcheckIntegrationSettings.vue';
import MakeComWebhookSettings from './integrations/makecom/MakeComWebhookSettings.vue';
import N8nWebhookSettings from './integrations/n8n/N8nWebhookSettings.vue';

@Component({
  name: 'agency-info-settings',
  components: {
    FlixcheckIntegrationSettings,
    MakeComWebhookSettings,
    N8nWebhookSettings,
  },
})
class IntegrationsSettings extends mixins(BaseMixin, PermissionMixin) {}

export default IntegrationsSettings;
